import {Fragment, useContext, useEffect, useState} from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";

import {
    StepCompanyData,
    StepCompanyEconomicSituation,
    StepRequestedDocumentation,
    StepRequestedFinancing,
    StepSuretiesData
} from "./steps";
import {Solicitation} from "../../types/solicitation/solicitationData";
import {CompanyContext, CompanyContextValue} from "./context/companyContext";
import StepperCustomDot from "../../views/forms/form-wizard/StepperCustomDot";
import {HttpClient} from "../../http/client/httpClient";
import StepperWrapper from "../../@core/styles/mui/stepper";
import {Client, ClientFields, ClientType} from "../../types/client/clientData";
import {HttpSolicitation} from "../../http/solicitation/httpSolicitation";

const steps = [
    {
        title: 'Datos de empresa',
    },
    {
        title: 'Datos de fiadores',
    },
    {
        title: 'Financiamiento Solicitado'
    },
    {
        title: 'Situación Econ. de Empresa'
    },
    {
        title: 'Documentación'
    }
]

export interface MiddleStepProps {
    handleNext: () => void,
    handlePrev: () => void,
    clientSolicitationId: number
}


const NewSolicitationStepper = () => {
    const [activeStep, setActiveStep] = useState<number>(0)
    const { clientId, clientSolicitationId, setClientSolicitationId } = useContext<CompanyContextValue>(CompanyContext);
    const [client, setClient] = useState<Client>()
    const [solicitation, setSolicitation] = useState<Solicitation>()
    const handleNext = () => {
        setActiveStep(activeStep + 1)
    }

    const handlePrev = () => {
        if (activeStep !== 0) {
            setActiveStep(activeStep - 1)
        }
    }
    
    const handlePrevMonotax = () => setActiveStep(activeStep - 2)

    const stepContents = (step: number) => {
        switch (step) {
            case 0:
                return <StepCompanyData client={client} handleNext={handleNext} solicitation={solicitation}/>
            case 1:
                return <StepSuretiesData handlePrev={handlePrev} handleNext={handleNext} clientSolicitationId={clientSolicitationId}/>
            case 2:
                return <StepRequestedFinancing handlePrev={handlePrev} handleNext={handleNext} clientSolicitationId={clientSolicitationId}/>
            case 3:
                return <StepCompanyEconomicSituation handlePrev={handlePrev}
                                                     handleNext={handleNext}
                                                     clientSolicitationId={clientSolicitationId}
                                                     isPhysical={client?.[ClientFields.ClientTypeCode] === ClientType.Fisica}
                                                     monotax={client?.[ClientFields.AfipResponsibilityTypeCode] === 6 || client?.[ClientFields.AfipResponsibilityTypeCode] === 13}
                />
            case 4:
                return <StepRequestedDocumentation handlePrev={client?.[ClientFields.AfipResponsibilityTypeCode] === 6 || client?.[ClientFields.AfipResponsibilityTypeCode] === 13 ? handlePrevMonotax : handlePrev} clientId={clientId} clientSolicitationId={clientSolicitationId}/>

            default:
                return null
        }
    }


    const renderContent = () => {
        return stepContents(activeStep)
    }
    
    useEffect(() => {
        HttpClient.getById(clientId).then((r) => {
            setClient(r)
        })
        
        if(clientSolicitationId !== 0){
            HttpSolicitation.getSolicitationById(clientSolicitationId).then((r) => {
                setSolicitation(r)
                localStorage.setItem('solicitationId', `${clientSolicitationId}`)
            })
        }
    }, [clientId, clientSolicitationId, activeStep])

    useEffect(() => {
        const id = localStorage.getItem('solicitationId');
        if(id) setClientSolicitationId(parseInt(id))
    }, [])

    
    return (
        <Fragment>
            <StepperWrapper sx={{ mb: 5 }}>
                <Stepper activeStep={activeStep} >
                    {steps.map((step, index) => {
                        return (
                            <Step key={index}>
                                <StepLabel StepIconComponent={StepperCustomDot}>
                                    <StepLabelDetail idx={index} title={step.title} activeStep={activeStep} setActiveStep={setActiveStep}/>
                                </StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
            </StepperWrapper>
            {renderContent()}
        </Fragment>
    )
}

interface StepLabelDetailProps {
    idx: number,
    title: string,
    activeStep: number,
    setActiveStep: (step: number) => void
}

export const StepLabelDetail = (props: StepLabelDetailProps) => {
    const { idx, title, activeStep, setActiveStep} = props
    
    const passed = activeStep > idx
    const onClickStep = () => {
        setActiveStep(idx)
    }
    
    return (
        <div className='step-label' onClick={passed ? onClickStep : () => {console.log(".")}}
             style={passed ? {cursor: 'pointer'} : {}}>
            <Typography fontWeight={700} fontSize={28}>{`${idx + 1}`}</Typography>
            <Typography fontSize={15} fontWeight={500} pl={2}>{title}</Typography>
        </div>
    )
}


export default NewSolicitationStepper